import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

import { Choice } from 'src/app/shared/components/select/choice.model';
import { BasicService } from 'src/app/shared/services/basic.service';
import { KakaotalkTemplatesService } from '../../kakaotalk-templates.service';
import { KakaotalkTemplateForm, KakaotalkTemplateUsageEnum } from '../../shared';
@Component({
  selector: 'app-kakaotalk-template-main',
  templateUrl: './kakaotalk-template-main.component.html',
  styleUrls: ['./kakaotalk-template-main.component.scss'],
})
export class KakaotalkTemplateMainComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup;
  @Input() template: KakaotalkTemplateForm;
  languageList = this.kakaotalkTemplatesService.getSupportedLanguages();
  languageCodesList = this.languageList.map(({ id }) => id);
  accountList: Choice[] = [];
  usagesList: Choice[] = [
    {
      id: KakaotalkTemplateUsageEnum.advisor,
      label: this.basicService.translate('parameters/kakaotalk-templates/details/main/usages/advisor'),
    },
    {
      id: KakaotalkTemplateUsageEnum.bot,
      label: this.basicService.translate('parameters/kakaotalk-templates/details/main/usages/bot'),
    },
  ];
  allSelected: boolean;
  kakaotalkAccountSettingsUrl: string;
  templateNameMaxLength = this.kakaotalkTemplatesService.getLimitations().maxLength.templateName;

  subscriptions = new Subscription();

  constructor(
    private kakaotalkTemplatesService: KakaotalkTemplatesService,
    private basicService: BasicService,
    @Inject('DropdownItemsFactory') private dropdownItemsService: any
  ) {}

  ngOnInit() {
    this.subscriptions.add(
      this.form.get('siteId').valueChanges.subscribe(value => {
        this.kakaotalkTemplatesService.createTemplateSiteIdUpdatedBS.next(value);
      })
    );
    this.kakaotalkTemplatesService.findAccounts().subscribe({
      next: () => {
        this.accountList = this.dropdownItemsService.buildSiteItems(this.kakaotalkTemplatesService.kakaotalkAccounts);
        if (this.accountList?.length === 1) {
          this.form.get('siteId').setValue(this.accountList[0].id);
        }
      },
    });
  }

  toggleAllOptions() {
    this.allSelected = !this.allSelected;

    if (this.allSelected) {
      this.form.get('languages').setValue(this.languageCodesList.slice());
    } else {
      this.form.get('languages').setValue([]);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
